import { Injectable } from '@angular/core';
import { ApiService } from '../../../core/services/api/api.service';
import { Observable } from 'rxjs';
import { TiimStudyParticipant } from '../../../models/tiim-study-participant';
import { CcStudyParticipant } from '../../../models/cc-study-participant';

@Injectable({
  providedIn: 'root',
})
export class StudyParticipantsService {
  getTiimStudyParticipants(studyId: number): Observable<TiimStudyParticipant[]> {
    return this.apiService.get<TiimStudyParticipant[]>(`/dashboard/study/${studyId}/participants`);
  }

  deleteStudyParticipant(studyId: number, participantId: number): Observable<string> {
    return this.apiService.delete<string>(`/dashboard/study/${studyId}/participant/${participantId}`, {
      responseType: 'text',
    });
  }

  sendTiimStudyParticipantNotification(participantId: number, message: string): Observable<string> {
    return this.apiService.post<string>(`/dashboard/participant/${participantId}/sendMsg`, { msg: message });
  }

  enrolTiimStudyParticipant(tiimStudyParticipant): Observable<TiimStudyParticipant> {
    return this.apiService.post<TiimStudyParticipant>(
      `/dashboard/study/${tiimStudyParticipant.study_id}/participant/${tiimStudyParticipant.participant_id}/` +
        `enrol/${tiimStudyParticipant.intervention_id}`,
      tiimStudyParticipant
    );
  }

  getCcStudyParticipants(studyId: number): Observable<CcStudyParticipant[]> {
    return this.apiService.get<CcStudyParticipant[]>(`/dashboard/study/${studyId}/participant-interventions`);
  }

  constructor(private apiService: ApiService) {}
}
